import React, { useContext } from 'react'
import TopNavigation from 'app/React/Components/Header/TopNavigation/TopNavigation'
import Logo from 'app/React/Components/Header/Logo'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer"

export default function Header() {
  const {
    currentVariant,
    isMenuOpen,
    setIsMenuOpen,
    currentStep,
  } = useContext(ConfiguratorContext)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const stepIndex = () => {
    const stepsArray = Object.values(currentVariant.steps)
    const index = stepsArray.findIndex((step) => step.step_id == currentStep) + 1
    return index < 1 ? 1 : index
  }

  return (
    <header>
      <Logo/>
      <TopNavigation/>
      <div className='top-title'>
        <span>{stepIndex()}.</span>
        &nbsp;
        {currentVariant.steps[currentStep].title}
      </div>
      <div
        id='config-navigation-toggle'
        onClick={toggleMenu}
        className={['config-navigation__toggle-icon', isMenuOpen ? 'open' : null].join(' ')}
      >
        <div className='open'/>
      </div>
    </header>
  )
}
